export default "__VITE_ASSET__BL94ZyB___"